export enum IgnoreLiftStatusEnum {
    IgnoreNotAllowed = 0,
    IgnoreCheckin = 1,
    IgnoreBoarded = 2
}
